import React, { useState } from "react";
import axios from "axios";
import Cross from "../assets/cross.png"

const ForgotPasswordPopup = ({ onClose }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent page reload
    console.log("Form submitted with email:", email); // Debug log

    setLoading(true);
    setError("");
    setMessage("");

    try {
      // Directly use axios to make the API call
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/users/forgot-password`, // Use the environment variable
        { email } // Pass the email as payload
      );

      console.log("API response:", response); // Debug log

      if (response.status === 200) {
        setMessage(
          response.data.message ||
            "Password recovery instructions sent to your email address"
        );
      }
    } catch (err) {
      console.error("Error during password recovery:", err); // Debug log
      setError(
        err.response?.data?.message || "An error occurred. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-[60] bg-black bg-opacity-50 px-4 sm:px-6 lg:px-8">
      <div className="relative bg-primary p-6 sm:p-8 lg:p-10 rounded-xl sm:rounded-2xl shadow-lg w-full max-w-xs sm:max-w-md lg:max-w-lg h-auto max-h-[90vh] overflow-y-auto">
        {/* Close Button */}
        <img
          src={Cross} // Replace with your image path
          alt="Close"
          className="absolute top-4 right-4 cursor-pointer w-3 h-3 md:w-5 md:h-5 hover:opacity-75"
          onClick={onClose}
        />

        {/* Title */}
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-black mb-2 pr-8 sm:pr-10">
          Recover Password
        </h2>
        <p className="text-[rgba(25,25,25,1)] mb-4 sm:mb-6 mt-2 sm:mt-4 text-sm sm:text-base">
          Enter backup email
        </p>

        <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
          <div className="flex items-start">
            {/* Error indicator bar */}
            {error && (
              <div className="w-1 bg-red-600 mr-3 rounded-sm h-[60px] sm:h-[70px] lg:h-[80px] mt-1" />
            )}

            <div className="flex-1 min-w-0">
              {error ? (
                <p className="text-red-700 font-semibold mb-2 text-sm sm:text-base">
                  This email is not registered
                </p>
              ) : (
                <label className="block text-sm sm:text-base font-medium text-black mb-2">
                  Email
                </label>
              )}
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Enter your email address"
                className={`w-full px-3 sm:px-4 py-2 sm:py-2.5 lg:py-3 rounded-lg focus:outline-none border-2 text-sm sm:text-base transition-all
          ${
            error
              ? "bg-gray-200 border-red-600 text-red-700"
              : "bg-primary border-black text-black focus:ring-2 focus:ring-black/20"
          }`}
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className={`w-full bg-black text-primary font-bold py-2.5 sm:py-3 lg:py-3.5 rounded-lg transition duration-200 text-sm sm:text-base lg:text-lg ${
              loading
                ? "opacity-50 cursor-not-allowed"
                : "hover:bg-gray-800 active:bg-gray-900"
            }`}
          >
            {loading ? "Sending..." : "Recover"}
          </button>
        </form>

        {/* Success Message */}
        {message && (
          <p className="mt-4 text-green-700 text-center font-medium text-sm sm:text-base px-2">
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPopup;
